// This component wraps the SubscriptionPage for use in the onboarding flow
// It's a thin wrapper that allows the subscription page to be used as an onboarding step
import { SubscriptionPage } from '@/features/subscription';

const Subscription = () => {
  return <SubscriptionPage />;
};

export default Subscription;
